import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import { Home } from './index';

export const HomePage = ({ user, notification, actions }) => {
    return <Home user={user} notification={notification} actions={actions} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
